import Vue from 'vue'

/**
 * 點擊「操作說明」時，發送 GA 事件並跳轉到外部連結
 * @param {string} link - 外部連結
 * @param {Object} GAEvent - GA 事件
 * @param {string} GAEvent.product_id - 特定功能名稱 ID
 * @param {string} GAEvent.product_name - 特定功能名稱（配合 i18n 轉換）
 * @param {string} GAEvent.subpage_name - 事件發生的功能分頁名稱（配合 i18n 轉換）
 */
export const helpDocClick = (link, GAEvent = { product_id: '', product_name: '', subpage_name: '' }) => {
  Vue.prototype.$sendGAEvent('help_doc_click', {
    product_id: GAEvent.product_id,
    product_name: GAEvent.product_name,
    subpage_name: GAEvent.subpage_name
  })
  Vue.prototype.$toExternaLink(link)
}
